import {
  DepartureAirportFilterComponent,
  GroupedDepartureAirportFilterComponent,
} from '@/scopes/search/components/DepartureAirportFilterComponent'
import {
  departureAirportFilterOptionsSelector,
  isLoadingSelector,
} from '@/scopes/search/quick-search/components/selectors'
import { useQuickSearchSelector } from '@/scopes/search/quick-search/infrastructure/store/useQuickSearchSelector'
import * as React from 'react'

export function DepartureAirportFilter({
  onConfirm,
}: {
  onConfirm: (selection: string[]) => void
}) {
  const departureAirportOptions = useQuickSearchSelector(departureAirportFilterOptionsSelector)
  const isLoading = useQuickSearchSelector(isLoadingSelector)
  const showGroups = departureAirportOptions.options.filter(o => o.groupInfo).length > 0
  const FilterComponent = showGroups ? GroupedDepartureAirportFilterComponent : DepartureAirportFilterComponent
  return (
    <FilterComponent
      id="departure-airport-duration-filter"
      onConfirm={onConfirm}
      options={departureAirportOptions.options}
      selectedOptions={departureAirportOptions.selectedOptions}
      disabled={isLoading || departureAirportOptions.options.length === 0}
      biggerBreakpoint
    />
  )
}
